var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeSetaLadoVerde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 11.970563741713704,
    width: 11.970563741712795,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.985281870855541, 5.985281870856279) rotate(315) translate(-5.985281870855541, -5.985281870856279)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 1,
    opacity: 1,
    fillRule: "evenodd",
    d: "M9.48959355725082 1.7322335420470196L10.196700338437374 10.238330199665539L1.7738634032737082 9.53122341847899L9.48959355725082 1.7322335420470196Z",
    fill: "#36D896"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeSetaLadoVerde);
export default __webpack_public_path__ + "static/media/icone-seta-lado-verde.0f6e4fbb7654b6759ebd596286fbb608.svg";
export { ForwardRef as ReactComponent };